module.exports = __webpack_public_path__ + "static/media/confluent.735f331c.png";